<script>
    import Scene from "./Scene.svelte";
    import StarRing from "../pre-comps/StarRing.svelte";
    import Tower from "../pre-comps/Elements/Tower.svelte";

    const layers = [
        StarRing,
        Tower,
    ];

</script>

<Scene layers={layers}></Scene>